/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';
import {
  CURRENT_ACTIVITY_FETCHING,
  CURRENT_ACTIVITY_FETCHING_DONE,
  CURRENT_ACTIVITY_FETCHING_ERROR,
  CurrentActivityActionType
} from 'store/action';
import {IPortalError} from 'utility/error-handler';
import {IActiveUserData} from 'views/analytics/current-activity';

export interface ICurrentActivityState {
  isFetching: boolean;
  error: null | IPortalError;
  currentActivity: IActiveUserData[];
}

const defaultState = {
  isFetching: false,
  error: null,
  currentActivity: null
};
const currentActivityReducer: Reducer<Readonly<ICurrentActivityState>, CurrentActivityActionType> = (
  state: ICurrentActivityState = defaultState,
  action: CurrentActivityActionType
) => {
  switch (action.type) {
    case CURRENT_ACTIVITY_FETCHING: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case CURRENT_ACTIVITY_FETCHING_DONE: {
      return {
        ...state,
        isFetching: false,
        error: null,
        currentActivity: action.payload.data
      };
    }

    case CURRENT_ACTIVITY_FETCHING_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    default:
      return state;
  }
};

export default currentActivityReducer;